export const AuthEnum = {
    TOKEN: 'TOKEN',
    ACCESS_TOKEN: 'ADUTOiDjJP1agVCP',
};
